import { type History, type Task } from "@repo/api";
import { RegionContainer } from "@repo/ui";

import {
  type TaskModalState,
  type TaskModalStateActions,
} from "./TaskModalReducer";
import { TaskModalView, type TaskModalViewProps } from "./TaskModalView";
import { TaskModalEdit } from "./edit/TaskModalEdit";

export type TaskModalDetailsProps = Pick<TaskModalViewProps, "taskDetails"> & {
  state: TaskModalState;
  actions: TaskModalStateActions;
  task?: Task;
  onMarkAsDone: (theTask: Task) => void;
  onDelete: () => void;
  hasCollision?: boolean;
  historyEntries?: History[];
  mutateSearchAppointments?: () => void;
};

export const TaskModalDetails = ({
  state,
  actions,
  task,
  onMarkAsDone,
  onDelete,
  hasCollision,
  historyEntries,
  taskDetails,
}: TaskModalDetailsProps) => {
  return (
    <RegionContainer>
      {state.mode === "VIEW" && (
        <TaskModalView
          state={state}
          actions={actions}
          task={task}
          historyEntries={historyEntries}
          onMarkAsDone={onMarkAsDone}
          onDelete={onDelete}
          taskDetails={taskDetails}
        />
      )}
      {(state.mode === "CREATE" || state.mode === "EDIT") && (
        <TaskModalEdit
          state={state}
          actions={actions}
          task={task}
          hasCollision={hasCollision}
        />
      )}
    </RegionContainer>
  );
};
